import { LinkButton, ClassicButton } from "../components/Buttons.js";

const Whitepaper = () => {
  return (
    <div className="container" id="whitepaper">
      <div className="row">
        <div className="col-12">
          <h3>
            Stay tuned for all the upcoming news and our press release updates!
          </h3>
        </div>
      </div>
      <div className="row">
        <div className="col-12 pre">
          <h2>The Whitepaper</h2>
          <h4>and the presentation!</h4>
        </div>
        <div className="col-12 col-md-6 pre" id="wp-pre">
          <LinkButton
            classname=""
            target="blank"
            link="https://lion-travelers.gitbook.io/lion-travelers/"
            text={
              <ClassicButton
                classname="btn btn-primary"
                text="📑&nbsp;Whitepaper"
              />
            }
          />
        </div>
        <div className="col-12 col-md-6 pre">
          <LinkButton
            classname=""
            target="blank"
            link="/docs/presentation.pdf"
            text={
              <ClassicButton
                classname="btn btn-primary"
                text="💻 Presentation"
              />
            }
          />
        </div>
      </div>
    </div>
  );
};

export default Whitepaper;
